/* =========================================================================
   OfficeLicense24 – Feinschliff II
   ------------------------------------------------------------------------
   Vier Muster von 21st.dev, von Hand nach reinem Vanilla-JS uebersetzt.
   Keine Bibliothek, kein Fremdaufruf, kein React, kein Tailwind:

     1  Zaehler        Zahlen laufen beim Sichtbarwerden von 0 zum Endwert
     2  Reiterlaeufer  ein Strich gleitet unter den aktiven Reiter
     3  Kaufleiste     erscheint, wenn der Kaufknopf aus dem Bild rollt
     4  Abschnittspunkte  eine Punktleiste zeigt, wo man auf der Seite steht

   ZWEI REGELN, DIE HIER UEBERALL GELTEN

   a) FAELLT ETWAS AUS, FEHLT NUR DIE ZIERDE. Kein Baustein versteckt
      Inhalt. Die Zahlen stehen bereits fertig im HTML - das Skript zaehlt
      nur zu ihnen hin. Der Reiterlaeufer ist ein zusaetzlicher Strich, die
      Reiter funktionieren ohne ihn genauso. Kaufleiste und Punktleiste
      sind Zugaben, die nichts verdecken.

   b) CANYON SCROLLT NICHT DAS DOKUMENT, sondern den Kasten .page-wrapper
      (html/body stehen auf overflow:hidden). Ein IntersectionObserver mit
      root: null wuerde nie ausloesen. Darum wird - wie in ol-motion.js -
      der wirklich scrollende Vorfahr gesucht und als Wurzel gesetzt.

   Alles Bewegte ist unter prefers-reduced-motion stillgelegt; die
   Funktion bleibt in jedem Fall erhalten.
   ========================================================================= */
(function () {
  'use strict';

  var wenigBewegung = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  /* ------------------------------------------------------ Scroll-Wurzel */
  function scrollWurzel() {
    var kasten = document.querySelector('.page-wrapper');
    if (!kasten) return null;
    var art = getComputedStyle(kasten).overflowY;
    if (art === 'auto' || art === 'scroll') return kasten;
    return null;
  }

  function texte() {
    var q = document.querySelector('[data-ol-fein]');
    return q ? q.dataset : {};
  }
  var wort = texte();

  /* ===================================================== 1  Zaehler
     Die Zahl steht schon richtig im HTML. Wird sie sichtbar, wird sie
     kurz auf 0 gesetzt und laeuft hoch. Ohne Beobachter oder bei
     reduzierter Bewegung passiert gar nichts - der Endwert steht ja da.
     Die Ziffernbreite ist per CSS auf tabular-nums festgelegt, also
     wackelt beim Zaehlen nichts daneben. */
  function zaehler() {
    var ziele = document.querySelectorAll('[data-ol-zaehler]:not([data-ol-zaehler-fertig])');
    if (!ziele.length) return;

    if (wenigBewegung || !('IntersectionObserver' in window) || !window.requestAnimationFrame) {
      ziele.forEach(function (el) { el.dataset.olZaehlerFertig = '1'; });
      return;
    }

    var beobachter = zaehler._b;
    if (!beobachter) {
      beobachter = zaehler._b = new IntersectionObserver(function (eintraege, selbst) {
        eintraege.forEach(function (e) {
          if (!e.isIntersecting) return;
          selbst.unobserve(e.target);
          lauf(e.target);
        });
      }, { root: scrollWurzel(), threshold: 0.4 });
    }

    ziele.forEach(function (el) {
      el.dataset.olZaehlerFertig = '1';
      beobachter.observe(el);
    });
  }

  function lauf(el) {
    var ziel = parseInt(el.dataset.olZaehler, 10);
    if (!isFinite(ziel) || ziel <= 0) return;
    var dauer = Math.min(1100, 320 + ziel * 22);
    var start = 0;

    function schritt(jetzt) {
      if (!start) start = jetzt;
      var anteil = Math.min(1, (jetzt - start) / dauer);
      // Weich auslaufend (ease-out cubic) - die letzten Zahlen kommen
      // langsamer, das liest sich ruhiger als lineares Hochzaehlen.
      var weich = 1 - Math.pow(1 - anteil, 3);
      el.textContent = String(Math.round(ziel * weich));
      if (anteil < 1) requestAnimationFrame(schritt);
      // Sicherheitsnetz: am Ende steht garantiert der echte Wert.
      else el.textContent = String(ziel);
    }
    requestAnimationFrame(schritt);
  }

  /* ============================================== 2  Reiterlaeufer
     Ein Strich gleitet unter den aktiven Reiter. Bewusst ein Strich und
     keine gefuellte Pille: so legt er sich nicht mit den vorhandenen
     Aktiv-Stilen der Reiterleisten an, sondern kommt dazu.

     Bedient werden zwei Leisten, die es im Shop schon gibt - die
     Themenreiter der FAQ und die Filterchips der Anleitungen. Beide
     Dateien bleiben unangetastet; hier wird nur von aussen gemessen. */
  var LEISTEN = [
    { kasten: '.bsfa-faq__tabs', teil: '[data-faq-tab]', aktiv: function (t) { return t.getAttribute('aria-selected') === 'true'; } },
    { kasten: '.ol-anl__chips', teil: '.ol-anl__chip', aktiv: function (t) { return t.classList.contains('ist-aktiv'); } }
  ];

  function reiter() {
    LEISTEN.forEach(function (art) {
      document.querySelectorAll(art.kasten).forEach(function (kasten) {
        if (kasten.dataset.olReiter) return;
        var teile = Array.prototype.slice.call(kasten.querySelectorAll(art.teil));
        if (teile.length < 2) return;
        kasten.dataset.olReiter = '1';
        kasten.classList.add('ol-fein-reiter');

        var laeufer = document.createElement('span');
        laeufer.className = 'ol-fein-laeufer';
        laeufer.setAttribute('aria-hidden', 'true');
        kasten.appendChild(laeufer);

        var geplant = false;
        function messen() {
          if (geplant) return;
          geplant = true;
          requestAnimationFrame(function () {
            geplant = false;
            var an = null;
            for (var i = 0; i < teile.length; i++) { if (art.aktiv(teile[i])) { an = teile[i]; break; } }
            if (!an) { laeufer.style.opacity = '0'; return; }
            // offsetLeft misst gegen den positionierten Vorfahren; die
            // Klasse ol-fein-reiter setzt dafuer position: relative.
            laeufer.style.opacity = '1';
            laeufer.style.width = an.offsetWidth + 'px';
            laeufer.style.transform = 'translateX(' + an.offsetLeft + 'px)';
          });
        }

        // Klick und Tastatur aendern den Aktiv-Zustand; der Beobachter
        // faengt beides ab, egal welches Skript ihn gesetzt hat.
        new MutationObserver(messen).observe(kasten, {
          subtree: true, attributes: true,
          attributeFilter: ['aria-selected', 'class', 'aria-pressed']
        });
        if ('ResizeObserver' in window) new ResizeObserver(messen).observe(kasten);
        else window.addEventListener('resize', messen, { passive: true });
        // Auf schmalen Bildschirmen rollt die Leiste waagerecht.
        kasten.addEventListener('scroll', messen, { passive: true });

        messen();
        // Schriften kommen spaeter an und aendern die Breiten.
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(messen);
        setTimeout(messen, 600);
      });
    });
  }

  /* ================================================= 3  Kaufleiste
     Rollt der eigentliche Kaufknopf nach oben aus dem Bild, erscheint
     unten eine schmale Leiste mit Name, Preis und demselben Knopf. Der
     Knopf in der Leiste klickt den echten an - die gesamte Logik des
     Themes (Variante, Menge, Fehlermeldungen) bleibt also die des
     Themes, hier wird nichts nachgebaut.

     Erscheint die Leiste nie, fehlt nichts: der echte Kaufbereich steht
     unveraendert auf der Seite. */
  var KAUF = [
    'product-form-component button[name="add"]',
    'form[action*="/cart/add"] button[type="submit"]',
    '.product-form-buttons button[type="submit"]',
    '.add-to-cart-button'
  ].join(',');

  function kaufleiste() {
    /* Canyon bringt auf der Produktseite eine eigene Kaufleiste mit
       (<sticky-add-to-cart>). Dann ist unsere ueberfluessig - zwei
       Leisten uebereinander waeren schlicht falsch. Um die des Themes
       kuemmert sich themenLeiste() weiter unten. */
    if (document.querySelector('sticky-add-to-cart')) return;
    var haupt = document.querySelector('main[data-template]');
    if (!haupt) return;
    if ((haupt.dataset.template || '').indexOf('product') !== 0) return;
    if (document.querySelector('[data-ol-kaufleiste]')) return;
    if (!('IntersectionObserver' in window)) return;

    var knopf = document.querySelector(KAUF);
    if (!knopf) return;

    var titelEl = haupt.querySelector('h1');
    var name = titelEl ? titelEl.textContent.trim().split('|')[0].trim() : '';
    if (!name) return;

    var preisEl = haupt.querySelector('.ol-preisbox__jetzt, .ol-preisbox .price, product-price .price, .price');

    var leiste = document.createElement('div');
    leiste.className = 'ol-fein-kauf';
    leiste.setAttribute('data-ol-kaufleiste', '');
    leiste.setAttribute('role', 'region');
    leiste.setAttribute('aria-label', wort.sticky || 'Schnellkauf');
    leiste.hidden = true;

    var text = document.createElement('span');
    text.className = 'ol-fein-kauf__text';
    var nameEl = document.createElement('span');
    nameEl.className = 'ol-fein-kauf__name';
    nameEl.textContent = name;
    text.appendChild(nameEl);

    var preisAus = null;
    if (preisEl) {
      preisAus = document.createElement('span');
      preisAus.className = 'ol-fein-kauf__preis';
      preisAus.textContent = preisEl.textContent.trim();
      text.appendChild(preisAus);
    }

    var mit = document.createElement('button');
    mit.type = 'button';
    mit.className = 'ol-fein-kauf__knopf';
    mit.textContent = (knopf.textContent || '').trim() || wort.kaufen || 'In den Warenkorb';
    mit.addEventListener('click', function () {
      // Der echte Knopf traegt die gesamte Logik. Ist er gesperrt,
      // holen wir ihn statt dessen ins Bild - dort steht die
      // Begruendung (Variante waehlen, ausverkauft ...).
      if (knopf.disabled || knopf.getAttribute('aria-disabled') === 'true') {
        knopf.scrollIntoView({ block: 'center', behavior: wenigBewegung ? 'auto' : 'smooth' });
        return;
      }
      knopf.click();
    });

    leiste.appendChild(text);
    leiste.appendChild(mit);
    document.body.appendChild(leiste);

    function zeigen(ja) {
      if (ja) {
        leiste.hidden = false;
        requestAnimationFrame(function () {
          leiste.classList.add('ist-da');
          document.body.style.setProperty('--ol-fein-leiste', leiste.offsetHeight + 'px');
          document.body.classList.add('ol-fein-mit-kauf');
        });
      } else {
        leiste.classList.remove('ist-da');
        document.body.classList.remove('ol-fein-mit-kauf');
        document.body.style.setProperty('--ol-fein-leiste', '0px');
        setTimeout(function () { if (!leiste.classList.contains('ist-da')) leiste.hidden = true; }, 240);
      }
    }

    // Die Leiste kommt erst, wenn der Kaufknopf NACH OBEN aus dem Bild
    // gerollt ist - nicht schon, bevor man ihn ueberhaupt gesehen hat.
    new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) {
        var oben = e.boundingClientRect.top < 0;
        zeigen(!e.isIntersecting && oben);
      });
    }, { root: scrollWurzel(), threshold: 0 }).observe(knopf);

    // Preis und Knopftext folgen dem Variantenwechsel.
    if (preisEl && preisAus) {
      new MutationObserver(function () {
        preisAus.textContent = preisEl.textContent.trim();
      }).observe(preisEl, { childList: true, subtree: true, characterData: true });
    }
    new MutationObserver(function () {
      var neu = (knopf.textContent || '').trim();
      if (neu) mit.textContent = neu;
    }).observe(knopf, { childList: true, subtree: true, characterData: true });
  }


  /* ======================================= 3b  Canyons Kaufleiste
     Das Theme hat auf der Produktseite eine eigene feste Leiste. Zwei
     Dinge fehlten ihr:

     1. Sie meldet ihre Hoehe niemandem. Der "nach oben"-Pfeil aus
        ol-chic steht ebenfalls unten rechts und sass auf dem Telefon
        mitten auf dem blauen Kaufknopf. Jetzt schreibt dieses Stueck
        die sichtbare Hoehe nach --ol-fein-leiste; das CSS rueckt den
        Pfeil hoch und blendet ihn auf schmalen Schirmen ganz aus.

     2. Sie kennt nur "In den Warenkorb". Wer zwei Lizenzen zusammen
        kauft, musste danach die ganze Seite hochscrollen, um zum Korb
        zu kommen. Der Knopf hier erscheint, sobald wirklich etwas
        drin liegt, mit der Stueckzahl daneben.

     Der Knopf fuehrt zum WARENKORB, nicht direkt zur Kasse: dort steht
     die Pflicht-Bestaetigung zum Widerrufsverzicht. Daran vorbei waere
     schneller und falsch. */
  function themenLeiste() {
    var host = document.querySelector('sticky-add-to-cart');
    if (!host) return;
    var bar = host.querySelector('.sticky-add-to-cart__bar');
    if (!bar) return;

    /* WARUM HIER EIN BEOBACHTER STEHT
       Canyon tauscht beim Variantenwechsel den INHALT dieser Leiste aus:
       sticky-add-to-cart.js hoert auf shopify:product:select, holt die
       Leiste frisch vom Server und setzt sie mit morph(..., childrenOnly)
       ein. Unser Link steht in dieser Serverantwort nicht drin und ging
       kommentarlos mit unter - gemessen auf der Seite
       /products/windows-server-2025-standard: nach dem Umschalten der
       Kernzahl fehlte der Link auch sechs Sekunden spaeter noch, erst
       ein Neuladen der Seite brachte ihn zurueck.

       Das Ereignis taugt nicht als Aufhaenger: es faellt, BEVOR die
       Antwort da ist, der Austausch kommt erst danach. Der Beobachter
       dagegen meldet genau den Austausch. Die Leiste selbst bleibt
       derselbe Knoten - morph ruehrt nur die Kinder an -, darum reicht
       ein Beobachter je Leiste; die Marke unten sorgt dafuer. */
    if (bar.dataset.olKorb) return;
    bar.dataset.olKorb = '1';

    /* ---- Weg zum Warenkorb ----
       Zuletzt nachgesehener Stueckzahl-Stand. null heisst: noch nicht
       nachgesehen - dann bleibt der Link verborgen und die Klasse am
       <body> unangetastet. */
    var korbZahl = null;

    function korblinkBauen() {
      var link = document.createElement('a');
      link.className = 'ol-fein-korblink';
      link.setAttribute('data-ol-korblink', '');
      link.href = wort.korbUrl || '/cart';
      link.hidden = true;
      link.innerHTML =
        '<svg viewBox="0 0 24 24" width="17" height="17" fill="none" aria-hidden="true">' +
        '<path d="M4 5h2.2l2 10.2h9.6l1.8-7.4H7" stroke="currentColor" stroke-width="1.8" ' +
        'stroke-linecap="round" stroke-linejoin="round"/>' +
        '<circle cx="9.4" cy="19" r="1.4" fill="currentColor"/>' +
        '<circle cx="16.6" cy="19" r="1.4" fill="currentColor"/></svg>' +
        '<span class="ol-fein-korblink__wort"></span>' +
        '<span class="ol-fein-korblink__zahl" data-ol-korbzahl></span>';
      link.querySelector('.ol-fein-korblink__wort').textContent = wort.korb || 'Warenkorb';
      link.setAttribute('aria-label', wort.korb || 'Warenkorb');
      return link;
    }

    /* Traegt den bekannten Stand ein und haelt die Klasse
       ol-fein-korb-da am <body> gleich: das CSS in ol-fein.liquid
       verbreitert daran die Leiste und blendet auf dem Telefon das
       Vorschaubild aus. */
    function zeigen(link) {
      if (korbZahl === null) return;
      link.hidden = korbZahl < 1;
      var zahl = link.querySelector('[data-ol-korbzahl]');
      if (zahl) zahl.textContent = korbZahl ? String(korbZahl) : '';
      document.body.classList.toggle('ol-fein-korb-da', korbZahl > 0);
    }

    /* Haengt den Link ein, falls er fehlt. Ist er schon da, geschieht
       nichts: sonst wuerde die eigene Einfuegung den Beobachter erneut
       ausloesen und die Leiste sich mit Links fuellen. Nachgesehen wird
       hier nie - eingetragen wird der zuletzt bekannte Stand. */
    function einhaengen() {
      var link = bar.querySelector('[data-ol-korblink]');
      if (!link) {
        link = korblinkBauen();
        bar.appendChild(link);
      }
      zeigen(link);
      return link;
    }

    new MutationObserver(function () {
      if (bar.querySelector('[data-ol-korblink]')) return;
      einhaengen();
      anstossen();
    }).observe(bar, { childList: true, subtree: true });

    function stand() {
      var url = wort.korbJson || '/cart.js';
      fetch(url, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (c) {
          korbZahl = (c && c.item_count) || 0;
          einhaengen();
          messen();
        })
        .catch(function () {});
    }

    /* Nachgesehen wird nur bei einer echten Korbaenderung. Canyon meldet
       die mit shopify:cart:lines-update am document; fertig ist sie
       erst, wenn das mitgereichte Versprechen eingeloest ist. Der Klick
       auf einen Kaufknopf bleibt als Netz fuer Wege, die dieses
       Ereignis nicht senden; zweimal nachsehen ist dort billiger, als
       den richtigen Zeitpunkt zu raten. */
    document.addEventListener('shopify:cart:lines-update', function (ev) {
      var p = ev && ev.promise;
      if (p && p.then) p.then(stand, stand);
      else stand();
    });

    var KAUFKNOEPFE = 'button[name="add"], .add-to-cart-button, form[action*="/cart/add"] button[type="submit"]';
    document.addEventListener('click', function (ev) {
      if (!ev.target.closest) return;
      if (!ev.target.closest(KAUFKNOEPFE)) return;
      setTimeout(stand, 900);
      setTimeout(stand, 2400);
    }, true);

    /* ---- Hoehe melden ---- */
    var wartet = false;
    function messen() {
      wartet = false;
      var r = bar.getBoundingClientRect();
      var sichtbar = Math.max(0, window.innerHeight - r.top);
      if (sichtbar > 4 && r.height > 0) {
        document.body.style.setProperty('--ol-fein-leiste', Math.round(Math.min(sichtbar, r.height)) + 'px');
        document.body.classList.add('ol-fein-mit-kauf');
      } else {
        document.body.style.setProperty('--ol-fein-leiste', '0px');
        document.body.classList.remove('ol-fein-mit-kauf');
      }
    }
    function anstossen() {
      if (wartet) return;
      wartet = true;
      requestAnimationFrame(messen);
    }

    var wurzel = scrollWurzel();
    window.addEventListener('scroll', anstossen, { passive: true });
    window.addEventListener('resize', anstossen);
    if (wurzel && wurzel !== window && wurzel.addEventListener) {
      wurzel.addEventListener('scroll', anstossen, { passive: true });
    }
    if ('ResizeObserver' in window) new ResizeObserver(anstossen).observe(bar);
    messen();
    einhaengen();
    stand();
  }

  /* ============================================ 4  Abschnittspunkte
     Eine schmale Punktleiste am rechten Rand der Startseite zeigt, in
     welchem Abschnitt man gerade steht, und springt auf Klick dorthin.
     Nur auf breiten Bildschirmen mit Maus - auf dem Handy waere sie im
     Weg. Findet sie weniger als drei Abschnitte mit Ueberschrift,
     entsteht sie gar nicht erst. */
  function punkte() {
    var haupt = document.querySelector('main[data-template]');
    if (!haupt) return;
    if ((haupt.dataset.template || '').indexOf('index') !== 0) return;
    if (document.querySelector('[data-ol-punkte]')) return;
    if (!('IntersectionObserver' in window)) return;
    if (!window.matchMedia || !window.matchMedia('(min-width: 1240px) and (hover: hover) and (pointer: fine)').matches) return;

    var abschnitte = [];
    haupt.querySelectorAll('.shopify-section').forEach(function (s) {
      var h = s.querySelector('h1, h2');
      var name = h ? h.textContent.trim() : '';
      if (name) abschnitte.push({ el: s, name: name.length > 40 ? name.slice(0, 39) + '…' : name });
    });
    if (abschnitte.length < 3) return;

    var nav = document.createElement('nav');
    nav.className = 'ol-fein-punkte';
    nav.setAttribute('data-ol-punkte', '');
    nav.setAttribute('aria-label', wort.punkte || 'Abschnitte dieser Seite');

    abschnitte.forEach(function (a, i) {
      var k = document.createElement('button');
      k.type = 'button';
      k.className = 'ol-fein-punkt';
      k.setAttribute('aria-label', a.name);
      var f = document.createElement('span');
      f.className = 'ol-fein-punkt__fahne';
      f.setAttribute('aria-hidden', 'true');
      f.textContent = a.name;
      k.appendChild(f);
      k.addEventListener('click', function () {
        a.el.scrollIntoView({ block: 'start', behavior: wenigBewegung ? 'auto' : 'smooth' });
      });
      nav.appendChild(k);
      a.knopf = k;
      if (i === 0) k.setAttribute('aria-current', 'true');
    });

    document.body.appendChild(nav);

    // Sichtbarkeitsanteil je Abschnitt, nach Position abgelegt - kein
    // Map noetig, die Liste ist ohnehin kurz und aendert sich nicht.
    abschnitte.forEach(function (a) { a.anteil = 0; });

    /* r19a-punkte (11.10.): nach der Scrollposition statt nach Sichtbarkeitsanteil.
       Vorher blieb der erste Punkt aktiv (Beobachter an der falschen Scroll-Wurzel,
       hohe Abschnitte erreichen nie 25 %). Jetzt: aktiv ist der letzte Abschnitt,
       dessen Oberkante ueber 40 % der Fensterhoehe liegt; ganz unten der letzte. */
    function markieren() {
      var grenze = window.innerHeight * 0.4;
      var bester = abschnitte[0];
      abschnitte.forEach(function (a) { if (a.el.getBoundingClientRect().top <= grenze) bester = a; });
      var w = scrollWurzel();
      var amEnde = w ? (w.scrollTop + w.clientHeight >= w.scrollHeight - 8)
                     : (window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 8);
      if (amEnde) bester = abschnitte[abschnitte.length - 1];
      abschnitte.forEach(function (a) {
        if (a === bester) a.knopf.setAttribute('aria-current', 'true');
        else a.knopf.removeAttribute('aria-current');
      });
    }
    var geplant = false;
    function anstossen() {
      if (geplant) return;
      geplant = true;
      window.requestAnimationFrame(function () { geplant = false; markieren(); });
    }
    window.addEventListener('scroll', anstossen, { passive: true });
    window.addEventListener('resize', anstossen, { passive: true });
    var wurzelKasten = scrollWurzel();
    if (wurzelKasten) wurzelKasten.addEventListener('scroll', anstossen, { passive: true });
    markieren();
  }

  /* ------------------------------------------------------------- Start */
  /* ==========================================================
     Akkordeons: immer nur eines offen
     ----------------------------------------------------------
     Auf jeder Seite stehen Klappzeilen untereinander - Fragen,
     Anleitungsschritte, Produktangaben. Waren mehrere zugleich
     offen, wanderte die Zeile, die man gerade las, beim naechsten
     Klick nach unten aus dem Bild; auf dem Handy war das nicht mehr
     zu verfolgen. Also schliesst sich beim Oeffnen einer Zeile die
     zuvor offene ihrer Gruppe - am Rechner genauso wie am Telefon.

     Als Gruppe gilt der naechstgelegene Vorfahre, der mehr als ein
     <details> enthaelt. Damit trennen sich Akkordeons verschiedener
     Abschnitte von selbst, ohne dass jeder Abschnitt etwas markieren
     muesste.

     `toggle` steigt nicht auf, deshalb wird in der EINFANGPHASE
     gelauscht - das erreicht auch Zeilen, die spaeter erst in die
     Seite kommen.

     Ausgenommen bleiben Kopfzeile, Menue-Schublade, Warenkorb-
     Schublade und Dialoge: dort ist ein <details> Navigation, kein
     Text, und ein automatisches Zuklappen waere im Weg. Einzelne
     Faelle lassen sich mit data-ol-akkordeon="aus" befreien.
     ========================================================== */
  var AKK_TABU = '#header-group, header, .header, .menu-drawer, .menu-drawer-container, cart-drawer, dialog, .search-modal';

  function akkGruppe(d) {
    var el = d.parentElement;
    while (el && el !== document.body && el.nodeType === 1) {
      if (el.querySelectorAll('details').length > 1) return el;
      el = el.parentElement;
    }
    return null;
  }

  function akkordeons() {
    if (document.documentElement.hasAttribute('data-ol-akk-an')) return;
    document.documentElement.setAttribute('data-ol-akk-an', '');

    document.addEventListener('toggle', function (e) {
      var d = e.target;
      if (!d || d.tagName !== 'DETAILS' || !d.open) return;
      if (d.getAttribute('data-ol-akkordeon') === 'aus') return;
      if (d.closest(AKK_TABU)) return;

      var gruppe = akkGruppe(d);
      if (!gruppe) return;

      var alle = gruppe.querySelectorAll('details');
      for (var i = 0; i < alle.length; i++) {
        var g = alle[i];
        if (g === d || !g.open) continue;
        if (g.getAttribute('data-ol-akkordeon') === 'aus') continue;
        // Nur echte Geschwister schliessen: ein <details> INNERHALB
        // der gerade geoeffneten Zeile gehoert nicht zur Gruppe, und
        // ein Vorfahre erst recht nicht.
        if (g.contains(d) || d.contains(g)) continue;
        if (akkGruppe(g) !== gruppe) continue;
        g.open = false;
      }
    }, true);
  }

  function anwenden() {
    zaehler();
    reiter();
  }

  function start() {
    anwenden();
    akkordeons();
    kaufleiste();
    themenLeiste();
    punkte();

    // Empfehlungen, Filterergebnisse und der Theme-Editor schieben
    // Abschnitte nachtraeglich in die Seite.
    var geplant = false;
    new MutationObserver(function () {
      if (geplant) return;
      geplant = true;
      requestAnimationFrame(function () { geplant = false; anwenden(); });
    }).observe(document.documentElement, { childList: true, subtree: true });

    document.addEventListener('shopify:section:load', function () {
      anwenden();
      kaufleiste();
    themenLeiste();
    });
  }

  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
})();
